const GET_IMPORT_LOCATIONS_PROGRESS_STATUS = 'GET_IMPORT_LOCATIONS_PROGRESS_STATUS';

export {
  GET_IMPORT_LOCATIONS_PROGRESS_STATUS,
};
